import { render, staticRenderFns } from "./categoriesPlaceholder.vue?vue&type=template&id=4dd8e1d3&"
import script from "./categoriesPlaceholder.vue?vue&type=script&lang=js&"
export * from "./categoriesPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./categoriesPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports